export function linkify(
    text: string,
    {limitLinkLength}: {limitLinkLength?: boolean} | undefined = {}
): string {
    if (!text) return ""
    //URLs starting with http://, https://, or ftp://
    const websitePattern1 =
        /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim
    //URLs starting with www. (without // before it, or it'd re-link the ones done above)
    const websitePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim
    //Change email addresses to mailto:: links
    const emailPattern3 = /(([a-zA-Z0-9_\-\.]+)@[a-zA-Z_]+?(?:\.[a-zA-Z]{2,6}))+/gim
    //Change tel to tel:: links
    const telPattern4 = /[0-9]{3}-[0-9]{3}-[0-9]{4}/gim

    const paragraphPattern5 = /\n/gim

    let resultText = text.replaceAll(/<script>.*<\/script>/gi, "")

    resultText = resultText.replaceAll(websitePattern1, (url) => {
        return `<a href="${url.trim()}" target="_blank">${
            limitLinkLength ? cropText(url) : url
        }</a>`
    })
    resultText = resultText.replaceAll(websitePattern2, (url) => {
        return `<a href="http://${url.trim()}" target="_blank">${
            limitLinkLength ? cropText(url) : url
        }</a>`
    })
    text.match(emailPattern3)?.forEach((item) => {
        resultText = resultText.replace(item, `<a href="mailto:${item}">${item}</a>`)
    })
    text.match(telPattern4)?.forEach((item) => {
        resultText = resultText.replace(
            item,
            `<a href="tel:${item.replace(/[\s-]/g, "")}">${item}</a>`
        )
    })
    text.match(paragraphPattern5)?.forEach((item) => {
        resultText = resultText.replace(item, "<br />")
    })

    return resultText
}

export const cropText = (text = "", limit = 40) => {
    if (text.length <= limit) {
        return text
    }
    return text.slice(0, limit / 2) + "..." + text.slice(-limit / 2)
}
